document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('use-billing-address');
  checkbox.addEventListener('change', () => {
    if(checkbox.checked){
      document.getElementById('ContactForm-shipping-address').value = document.getElementById('ContactForm-billing-address').value;
    }else{
      document.getElementById('ContactForm-shipping-address').value = '';
    }
  });
});